/* eslint-disable jsx-a11y/heading-has-content */
import React from 'react';
import PropTypes from 'prop-types';

const BlockComponentTitle = ({ children, name, ...props }) => (
  <h5
    className="flex justify-between text-dark-grey mt0 mb1 mt2 weight-600"
    {...props}
  >
    <div style={{ width: '100%' }}>{children}</div>
  </h5>
);

BlockComponentTitle.defaultProps = {
  children: null,
};

BlockComponentTitle.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default BlockComponentTitle;
